/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Message } from '../models';
/**
 * AbliefernachweisService - axios parameter creator
 * @export
 */
export const AbliefernachweisServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Liefert alle Aufträge für den aktuellen Mandanten
         * @summary Auftrag Abliefernachweis
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbliefernachweis: async (id?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/abliefernachweis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AbliefernachweisService - functional programming interface
 * @export
 */
export const AbliefernachweisServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AbliefernachweisServiceAxiosParamCreator(configuration)
    return {
        /**
         * Liefert alle Aufträge für den aktuellen Mandanten
         * @summary Auftrag Abliefernachweis
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAbliefernachweis(id?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAbliefernachweis(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AbliefernachweisService - factory interface
 * @export
 */
export const AbliefernachweisServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AbliefernachweisServiceFp(configuration)
    return {
        /**
         * Liefert alle Aufträge für den aktuellen Mandanten
         * @summary Auftrag Abliefernachweis
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbliefernachweis(id?: number, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getAbliefernachweis(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AbliefernachweisService - interface
 * @export
 * @interface AbliefernachweisService
 */
export interface AbliefernachweisServiceInterface {
    /**
     * Liefert alle Aufträge für den aktuellen Mandanten
     * @summary Auftrag Abliefernachweis
     * @param {number} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbliefernachweisServiceInterface
     */
    getAbliefernachweis(id?: number, options?: any): AxiosPromise<Array<string>>;

}

/**
 * AbliefernachweisService - object-oriented interface
 * @export
 * @class AbliefernachweisService
 * @extends {BaseAPI}
 */
export class AbliefernachweisService extends BaseAPI implements AbliefernachweisServiceInterface {
    /**
     * Liefert alle Aufträge für den aktuellen Mandanten
     * @summary Auftrag Abliefernachweis
     * @param {number} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbliefernachweisService
     */
    public getAbliefernachweis(id?: number, options?: any) {
        return AbliefernachweisServiceFp(this.configuration).getAbliefernachweis(id, options).then((request) => request(this.axios, this.basePath));
    }
}
